import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(public)/auth/register/page.tsx");
